const sentencias = {
    BuscarExpediente: 'SICSEN/Administracion/BuscarExpediente', 
    SiguienteExpediente: 'SICSEN/Administracion/SiguienteExpediente', 
    ObtenerAreaIdDelUsuario: 'SICSEN/Administracion/ObtenerAreaIdDelUsuario',
    ObtenerTiposDeDocumentosIdYDBId : 'SICSEN/Administracion/ObtenerTiposDeDocumentosIdYDBId',
    SubirArchivo: 'SICSEN/Administracion/SubirArchivoSentencia',
    TestarSentencia: 'SICSEN/Administracion/TestarSentencia',
    GuardarSentencia: 'SICSEN/Administracion/GuardarSentencia',
    GenerarCopiaArchivoSentenciaParaEdicion: 'SICSEN/Administracion/GenerarCopiaArchivoSentenciaParaEdicion',
    CancelarAltaCambiosSentencia: 'SICSEN/Administracion/CancelarAltaCambiosSentencia',
    EliminarSentencia: 'SICSEN/Administracion/EliminarSentencia',
    PermisosAcciones: 'SICSEN/Administracion/PermisosAcciones'
}

const administracion = {
    sentencias: sentencias
}

export default administracion;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICSEN/sistema/administracion/administracion.js
// module id = null
// module chunks = 